import select from './select'
import date from './date'
import dateTimePicker from './dateTimePicker'
import text from './text'
import upload from './upload'
import fileUpload from './fileUpload'
import checkboxUpload from './checkboxUpload'
import checkbox from './checkbox'
import radioButton from './radioButton'
import textarea from './textarea'

export const SelectInput = select
export const DateInput = date
export const DateTimePicker = dateTimePicker
export const TextInput = text
export const UploadInput = upload
export const FileUploadInput = fileUpload
export const CheckBoxUpload = checkboxUpload
export const Checkbox = checkbox
export const RadioGroup = radioButton
export const TextArea = textarea
